module.exports = __webpack_public_path__ + "img/40-03.a1fdc795.png";